import { TbHomePlus, TbHomeStar } from "react-icons/tb";
import { IoBookOutline } from "react-icons/io5";
import { GiCommercialAirplane } from "react-icons/gi";
import { BiPurchaseTagAlt } from "react-icons/bi";
import { MdOutlineEventAvailable } from "react-icons/md";
import { SiMicrosoft } from "react-icons/si";
import { PiCoinsThin } from "react-icons/pi";
import { LiaRingSolid } from "react-icons/lia";
import { MdOutlineHealthAndSafety } from "react-icons/md";
import { CiMoneyBill } from "react-icons/ci";
import { GrAccessibility } from "react-icons/gr";

import { v4 as uuid } from "uuid";

export const DEFAULT_LOAN_PURPOSE_OPTIONS = [
  {
    id: uuid(),
    row: [
      {
        id: uuid(),
        label: "Home Building",
        icon: <TbHomePlus sx={{ fontSize: "30px" }} />,
      },
      {
        id: uuid(),
        label: "Home Renovation",
        icon: <TbHomeStar sx={{ fontSize: "30px" }} />,
      },
    ],
  },
  {
    id: uuid(),
    row: [
      {
        id: uuid(),
        label: "Travel",
        icon: <GiCommercialAirplane sx={{ fontSize: "30px" }} />,
      },
      {
        id: uuid(),
        label: "Education",
        icon: <IoBookOutline sx={{ fontSize: "30px" }} />,
      },
    ],
  },
  {
    id: uuid(),
    row: [
      {
        id: uuid(),
        label: "Ocassion in Family",
        icon: <MdOutlineEventAvailable sx={{ fontSize: "30px" }} />,
      },
      {
        id: uuid(),
        label: "Purchase of Household",
        icon: <BiPurchaseTagAlt sx={{ fontSize: "30px" }} />,
      },
    ],
  },
  {
    id: uuid(),
    row: [
      {
        id: uuid(),
        label: "Business Use",
        icon: <MdOutlineEventAvailable sx={{ fontSize: "30px" }} />,
      },
      {
        id: uuid(),
        label: "Office Renovation",
        icon: <SiMicrosoft sx={{ fontSize: "30px" }} />,
      },
    ],
  },
  {
    id: uuid(),
    row: [
      {
        id: uuid(),
        label: "Working Capital",
        icon: <PiCoinsThin sx={{ fontSize: "30px" }} />,
      },
      {
        id: uuid(),
        label: "Marriage",
        icon: <LiaRingSolid sx={{ fontSize: "30px" }} />,
      },
    ],
  },
  {
    id: uuid(),
    row: [
      {
        id: uuid(),
        label: "Personal Crisis",
        icon: <MdOutlineHealthAndSafety sx={{ fontSize: "30px" }} />,
      },
      {
        id: uuid(),
        label: "Other",
        icon: <GrAccessibility sx={{ fontSize: "30px" }} />,
      },
    ],
  },
];

export const VIDHI_LOAN_PURPOSE = [
  {
    id: uuid(),
    row: [
      {
        id: uuid(),
        label: "Initial Home loan Down Payment ",
        icon: <TbHomePlus sx={{ fontSize: "30px" }} />,
      },
      {
        id: uuid(),
        label: "Stamp Duty",
        icon: <CiMoneyBill sx={{ fontSize: "30px" }} />,
      },
    ],
  },
  {
    id: uuid(),
    row: [
      {
        id: uuid(),
        label: "Registration charges",
        icon: <CiMoneyBill sx={{ fontSize: "30px" }} />,
      },
      {
        id: uuid(),
        label: "Other",
        icon: <GrAccessibility sx={{ fontSize: "30px" }} />,
      },
    ],
  },
];

export const getLoanPurposeOptionsByDomainName = (domain) => {
  if (!domain) return DEFAULT_LOAN_PURPOSE_OPTIONS;

  switch (domain) {
    case "rocketloanz":
      return VIDHI_LOAN_PURPOSE;
    default:
      return DEFAULT_LOAN_PURPOSE_OPTIONS;
  }
};
